import { apiAxios } from '@/lib/apiAxios';
export const createPaddleCheckout = ({ workspaceId, planCode, period, }) => apiAxios
    .post(`/workspaces/${workspaceId}/billings/paddle/checkout`, { planCode, period })
    .then((r) => r.data);
